import React, { useEffect, useState } from 'react';

const SplashScreen = ({ onComplete }) => {
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSplash(false);
      onComplete();
    }, 3000); // Show for 3 seconds

    return () => clearTimeout(timer);
  }, [onComplete]);

  if (!showSplash) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: '#1a1a2e',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999
    }}>
      <video
        autoPlay
        muted
        playsInline
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover'
        }}
        onEnded={onComplete}
      >
        <source src="/splash-video.mp4" type="video/mp4" />
        {/* Fallback for browsers that don't support video */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          color: 'white'
        }}>
          <img 
            src="/flirteen-logo.png" 
            alt="Flirteen" 
            style={{ width: '200px', height: '200px', marginBottom: '20px' }}
          />
          <h1 style={{ fontSize: '2rem', margin: 0 }}>Flirteen</h1>
        </div>
      </video>
    </div>
  );
};

export default SplashScreen;